/* eslint-disable */

export const protobufPackage = "od_protos.sell.seller.data";

export enum SellerExperience {
  SELLER_EXPERIENCE_UNKNOWN = 0,
  SELLER_EXPERIENCE_DIRECT_TO_CONSUMER = 1,
  SELLER_EXPERIENCE_AGENT_LED_OFFERS = 2,
  SELLER_EXPERIENCE_AGENT_ACQUISITION = 3,
  SELLER_EXPERIENCE_DENIED = 4,
  UNRECOGNIZED = -1,
}

export function sellerExperienceFromJSON(object: any): SellerExperience {
  switch (object) {
    case 0:
    case "SELLER_EXPERIENCE_UNKNOWN":
      return SellerExperience.SELLER_EXPERIENCE_UNKNOWN;
    case 1:
    case "SELLER_EXPERIENCE_DIRECT_TO_CONSUMER":
      return SellerExperience.SELLER_EXPERIENCE_DIRECT_TO_CONSUMER;
    case 2:
    case "SELLER_EXPERIENCE_AGENT_LED_OFFERS":
      return SellerExperience.SELLER_EXPERIENCE_AGENT_LED_OFFERS;
    case 3:
    case "SELLER_EXPERIENCE_AGENT_ACQUISITION":
      return SellerExperience.SELLER_EXPERIENCE_AGENT_ACQUISITION;
    case 4:
    case "SELLER_EXPERIENCE_DENIED":
      return SellerExperience.SELLER_EXPERIENCE_DENIED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SellerExperience.UNRECOGNIZED;
  }
}

export function sellerExperienceToJSON(object: SellerExperience): string {
  switch (object) {
    case SellerExperience.SELLER_EXPERIENCE_UNKNOWN:
      return "SELLER_EXPERIENCE_UNKNOWN";
    case SellerExperience.SELLER_EXPERIENCE_DIRECT_TO_CONSUMER:
      return "SELLER_EXPERIENCE_DIRECT_TO_CONSUMER";
    case SellerExperience.SELLER_EXPERIENCE_AGENT_LED_OFFERS:
      return "SELLER_EXPERIENCE_AGENT_LED_OFFERS";
    case SellerExperience.SELLER_EXPERIENCE_AGENT_ACQUISITION:
      return "SELLER_EXPERIENCE_AGENT_ACQUISITION";
    case SellerExperience.SELLER_EXPERIENCE_DENIED:
      return "SELLER_EXPERIENCE_DENIED";
    case SellerExperience.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
